export const fastDuration = 240
export const slowDuration = 400

export const fastTransition = `${fastDuration}ms ease-in-out`
export const slowTransition = `${slowDuration}ms ease-in-out`
